module.exports = require("create-hash");;